/* eslint-disable import/extensions */
import { PAGES } from '../../constants/GLOBAL_VARIABLE.js'
import { Feature } from '../common/index.js'

class AccountSetting extends Feature {
  constructor({ mainUrl }) {
    super({ namespace: 'sa', enumKey: 'SA' })
    this.mainUrl = mainUrl || 'https://signin.nexon.com'

    const {
      redirect_uri: redirectUri,
    } = this.queryParamWithCookie

    this.redirectUri = redirectUri ? decodeURIComponent(redirectUri) : ''
  }

  setCookie() {
    const cookieData = {
      ...this.queryParamWithCookie, // 쿼리 파람으로 읽어온 값을 쿠키에 저장
    }

    this.namespaceCookie.setCookie(cookieData)
  }

  /**
   * goto Show Account Menu 페이지
   */
  gotoShowAccountMenuPage() {
    this.setCookie()
    this.navigateToUrlWithoutHistory(`${this.mainUrl}/${PAGES.SA_SHOW_ACCOUNT_MENU}`)
  }

  redirect() {
    super.redirect(this.redirectUri)
  }

  processAccountSetting() {
    try {
      if (this.hasResponse()) {
        this.redirect()
        return
      }

      this.gotoShowAccountMenuPage()
    } catch (e) {
      console.error('[processAccountSetting]', e)
    }
  }
}

export default AccountSetting
